export default __webpack_public_path__ + "static/media/realitybytes_s.43a08f5e.jpg";